import RepatForm from 'store/modules/Pages/RepatForm'
import store from 'definitions/store'

const Init = {
  init(name) {
    if (!store[name]) {
      store.registerModule(name, RepatForm)

      Init.initDefaultValues(name)
    }
  },
  initDefaultValues(name) {
    if (typeof pageData !== "undefined") {
      store.commit(`${name}/setPageData`, pageData)
    }

  }
}

export default Init
